import { IModalWarning as IAlertModalWarning } from '../repositories/chats/entities/spam_modal_warning/ModalWarning';

export enum EAlert {
  Spam = 'spam',
  Archive = 'archive',
  Info = 'info',
  FileUploadError = 'fileUploadError',
  MessageHasLinkToAnotherService = 'messageHasLinkToAnotherService',
  MessageСontainsForbiddenText = 'messageСontainsForbiddenText',
  NotFoundChat = 'notFoundChat',
  ChatsLinkError = 'chatsLinkError',
}

export enum EFileError {
  Size = 'Размер файла слишком большой, попробуйте выбрать другой',
  Type = 'Неподдерживаемый тип файла, попробуйте выбрать другой',
}

export type TAlertButton = {
  text: string;
  onClick: () => void;
};

export enum EChatsLinkErrorType {
  ResolveError = 'resolveError',
  UnknownError = 'unknownError',
}

export type TChatsLinkResolveError = {
  type: EChatsLinkErrorType.ResolveError;
};

export type TAlertChatsLinkError = {
  type: EChatsLinkErrorType;
  retryUrl?: string;
};
export interface IAlertState {
  isVisible: boolean;
  message?: string;
  type?: EAlert;
  chatId?: string;
  modalWarning?: IAlertModalWarning;
  button?: TAlertButton;
  chatsLinkError?: TAlertChatsLinkError;
}

export type { IAlertModalWarning };
